import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { toWidget , toWidgetEditable } from '@ckeditor/ckeditor5-widget/src/utils'
import Widget from '@ckeditor/ckeditor5-widget/src/widget'
import InsertCollapsableCommand from './collapsable-command'

export default class collapsableEditing extends Plugin {
    static get requires() {
        return [ Widget ]
    }


    init() {
        console.log( 'collapsableEditing#init() got called' );
        this._defineSchema(); 
        this._defineConverters();     
        this.editor.commands.add( 'insertCollapsable', new InsertCollapsableCommand( this.editor ) );

    }

    _defineSchema() {                                                          
        const schema = this.editor.model.schema;

        schema.register( 'collapsable', {
            // Behaves like a self-contained object (e.g. an image).
            isObject: true,

            // Allow in places where other blocks are allowed (e.g. directly in the root).
            allowWhere: '$block'
        } );

        schema.register( 'collapsableTitle', {
            // Cannot be split or left by the caret.
            isLimit: true,

            allowIn: 'collapsable',

            // Allow content which is allowed in blocks (i.e. text with attributes).
            allowContentOf: '$block'
        } );

        schema.register( 'collapsableDescription', {
            // Cannot be split or left by the caret.
            isLimit: true,

            allowIn: 'collapsable',

            // Allow content which is allowed in the root (e.g. paragraphs).
            allowContentOf: '$root'
        } );
    }

    _defineConverters() {                                                     
        const conversion = this.editor.conversion;

        // <simpleBox> converters
        conversion.for( 'upcast' ).elementToElement( {
            model: 'collapsable',
            view: {
                name: 'section',
                classes: 'collapsable-box'
            }
        } );
        conversion.for( 'dataDowncast' ).elementToElement( {
            model: 'collapsable',
            view: {
                name: 'section',
                classes: 'collapsable-box'
            }
        } );
        conversion.for( 'editingDowncast' ).elementToElement( {
            model: 'collapsable',
            view: ( modelElement, { writer } ) => {
                const section = writer.createContainerElement( 'section', { class: 'collapsable-box' } );

                return toWidget( section, writer, { label: 'Collapsable Box' } );
            }
        } );

        // <simpleBoxTitle> converters
        conversion.for( 'upcast' ).elementToElement( {
            model: 'collapsableTitle',
            view: {
                name: 'h1',
                classes: 'collapsable-title'
            }
        } );
        conversion.for( 'dataDowncast' ).elementToElement( {
            model: 'collapsableTitle',
            view: {
                name: 'h1',
                classes: 'collapsable-title'
            }
        } );
        conversion.for( 'editingDowncast' ).elementToElement( {
            model: 'collapsableTitle',
            view: ( modelElement, { writer: viewWriter } ) => {
                // Note: You use a more specialized createEditableElement() method here.
                console.log(viewWriter , writer)
                const h1 = viewWriter.createEditableElement( 'h1', { class: 'collapsable-title' } );

                return toWidgetEditable( h1, viewWriter );
            }
        } );

        // <simpleBoxDescription> converters
        conversion.for( 'upcast' ).elementToElement( {
            model: 'collapsableDescription',
            view: {
                name: 'div',
                classes: 'collapsable-description'
            }
        } );
        conversion.for( 'dataDowncast' ).elementToElement( {
            model: 'collapsableDescription',
            view: {
                name: 'div',
                classes: 'collapsable-description'
            }
        } );
        conversion.for( 'editingDowncast' ).elementToElement( {
            model: 'collapsableDescription',
            view: ( modelElement, { writer: viewWriter } ) => {
                // Note: You use a more specialized createEditableElement() method here.
                console.log(viewWriter, writer)
                const div = viewWriter.createEditableElement( 'div', { class: 'collapsable-description' } );

                return toWidgetEditable( div, viewWriter );
            }
        } );
    }

}
